import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation,  Input  } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { ReactivosService } from "../../services/reactivos.service";
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

@Component({
    selector     : 'native',
    templateUrl  : './native.component.html',
    styleUrls    : ['./native.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NativeComponent {
@Input('pasoCompleto') pasoCompleto?: boolean;

  reactivos: any;
  instituto:any;
// pasoCompleto?: boolean;

  constructor(private reactivosService: ReactivosService,
              public snackBar: MatSnackBar,
              private wizardService: WizardService,
              private _fuseTranslationLoaderService: FuseTranslationLoaderService,
              private serviceTranslate: TranslateService) {

      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });



  }

  test(){
    let obj = {
    "gptw": {
        "logo": "../assets/images/logo/logoGPTW2.png",
        "name": "Great Place To Work (r) 2019"
    },
    "screen": {
        "screenId": 1,
        "screenName": "Login",
        "customContent": {
            "languageSelection": "Select language",
            "msgAccess": "Access",
            "text": "<br><p>Welcome to the NewCorp Great Place to Work<sup>®</sup> Survey.</p><p>This survey is designed to give you the opportunity to tell us how you feel about your workplace experience. <br>You will have the opportunity to evaluate both your work and the overall organization as a place to work in a variety of -areas.</p><p>To the end of the survey, you will also have the opportunity to share your personal views on what makes your organization an excellent place to work and your suggestions for improvement.</p><p>The Great Place to Work<sup>®</sup> The survey requires double perspective responses from you.</p><p><strong>For each statement, you must provide 2 responses: by Workgroup and by Organization </strong>.</p><p>Check your answers based on your experience using the following definitions:</p><p><strong>Workgroup</strong> refers to your experience within your division <br>strong>Organization </strong> refers to your overall experience working at NewCorp <br><strong>Administration </strong>. under <strong>Workgroup</strong> refers to its reporting officer /team leader<br><strong>Government </strong> under <strong>Organization </strong> refers to the directors and above </p><br>",
            "inputPlaceHolderUser": "User",
            "inputPlaceHolderPass": "Password",
            "buttons": {
                "login": {
                    "label": "Start"
                }
            }
        }
    }
}
  //console.log(JSON.stringify(obj));
}


  ngOnInit() {

    let str = "{\"gptw\":{\"logo\":\"../assets/images/logo/logoGPTW2.png\",\"name\":\"Great Place To Work (r) 2019\"},\"screen\":{\"screenId\":1,\"screenName\":\"Login\",\"customContent\":{\"languageSelection\":\"Select language\",\"msgAccess\":\"Access\",\"text\":\"<br><p>Welcome to the NewCorp Great Place to Work<sup>®</sup> Survey.</p><p>This survey is designed to give you the opportunity to tell us how you feel about your workplace experience. <br>You will have the opportunity to evaluate both your work and the overall organization as a place to work in a variety of -areas.</p><p>To the end of the survey, you will also have the opportunity to share your personal views on what makes your organization an excellent place to work and your suggestions for improvement.</p><p>The Great Place to Work<sup>®</sup> The survey requires double perspective responses from you.</p><p><strong>For each statement, you must provide 2 responses: by Workgroup and by Organization </strong>.</p><p>Check your answers based on your experience using the following definitions:</p><p><strong>Workgroup</strong> refers to your experience within your division <br>strong>Organization </strong> refers to your overall experience working at NewCorp <br><strong>Administration </strong>. under <strong>Workgroup</strong> refers to its reporting officer /team leader<br><strong>Government </strong> under <strong>Organization </strong> refers to the directors and above </p><br>\",\"inputPlaceHolderUser\":\"User\",\"inputPlaceHolderPass\":\"Password\",\"buttons\":{\"login\":{\"label\":\"Start\"}}}}}";
    this.getReactivos();
    this.test();
    this.obtieneInstituto();

  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituo "+this.instituto);
  }

  public getReactivos(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    console.log("get reactivos");
    console.log(data);
    this.reactivosService.getReactivos(data)
    .subscribe(response => {
      console.log(response);
      if(response['success'] == true){
        if(response['reactivos'].length > 0){
          this.reactivos = response['reactivos'];
        }else{
          this.insertaReactivos();
        }

      }

    }, error => {
      console.log("error", error);
    });
  }

  public insertaReactivos(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.reactivosService.insertaCatalogoReactivos(data)
    .subscribe(response => {
      if(response['success'] == true){
        this.reactivos = response['reactivos'];
      }

    }, error => {
      console.log("error", error);
    });
  }

  onBlurPregunta(event,pregunta){
    if(event.target.value.length > 0){
      let data = {
        productoId: localStorage.getItem('productoID'),
          idReactivo: pregunta._id,
          pregunta: event.target.value
      };
      this.reactivosService.updateReactivo(data)
      .subscribe(response => {
        console.log(response);
        if(response['success'] == true){
          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.REACTIVOS.QUESTIONUPDATEDOK'),this.serviceTranslate.instant('ALERTS.OK'));

        }

      }, error => {
        console.log("error", error);
      });
      //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));

    }else{
      this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDFAIL'),this.serviceTranslate.instant('ALERTS.OK'));
    }
  }

  deletePregunta(event,pregunta){
      let data = {
          productoId: localStorage.getItem('productoID'),
          idReactivo: pregunta._id
      };
      this.reactivosService.deleteReactivo(data)
      .subscribe(response => {
        console.log(response);
        if(response['success'] == true){
          this.getReactivos();
          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.REACTIVOS.QUESTIONUPDATEDOK'),this.serviceTranslate.instant('ALERTS.OK'));

        }

      }, error => {
        console.log("error", error);
      });
  }

  agregaPregunta(){
    let data = {
      productoId: localStorage.getItem('productoID'),
      orden: this.reactivos[this.reactivos.length-1].orden+1,
      pregunta: "",
      tipoAgregado: 0
    }
    this.reactivosService.saveReactivo(data)
    .subscribe(response => {
      console.log(response);
      if(response['success'] == true){
        this.reactivos.push({
          obligatorio: 0,
          orden: this.reactivos[this.reactivos.length-1].orden+1,
          pregunta: "",
          traducciones: [],
          vivoReactivo: 1,
          _id: response['newReactivo']['_id']
        });
      }

    }, error => {
      console.log("error", error);
    });
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }


}
